import { ZfFormField, ZfInput, ZfSelectOption } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { LiquidityDateRange } from '../../../app/api/generated/client';
import { useLiquidityCalculationData } from '../../hooks';

const LIQUIDITY_DATE_RANGES: LiquidityDateRange[] = ['ONE_YEAR', 'TWO_YEARS', 'THREE_YEARS'];

export const LiquidityCalculatorDateRangeSelect: FunctionComponent = () => {
    const { t } = useTranslation();
    const calculationData = useLiquidityCalculationData();

    if (calculationData.isLoading) return null;

    const onSelectChange = (event: CustomEvent<string | string[]>) => {
        calculationData.updateScopeRange(event.detail as LiquidityDateRange);
    };

    return (
        <ZfFormField style={{ paddingBottom: 'var(--padding-bottom-sm)' }}>
            <ZfInput type="select" value={calculationData.scopeRange} onSelectChange={onSelectChange}>
                {LIQUIDITY_DATE_RANGES.map((range) => (
                    <ZfSelectOption key={range} value={range} description={t(`liquidityCalculatorSettings.dateRange.${range}`)} />
                ))}
            </ZfInput>
        </ZfFormField>
    );
};
